import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

export type DownloadState = { type: 'start' } | { type: 'success' } | { type: 'error'; error?: HttpErrorResponse };

@Injectable({ providedIn: 'root' })
export class DownloadStateService {
  private readonly _states = signal<Record<string, DownloadState>>({});

  public readonly states = this._states.asReadonly();

  public start(key: string): void {
    this._states.update(states => ({ ...states, [key]: { type: 'start' } }));
  }

  public success(key: string): void {
    this._states.update(states => ({ ...states, [key]: { type: 'success' } }));

    setTimeout(() => {
      this._states.update(states => {
        if (states[key]?.type !== 'success') {
          return states;
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [key]: _, ...rest } = states;
        return rest;
      });
    }, 2000);
  }

  public error(key: string, err?: HttpErrorResponse): void {
    this._states.update(states => ({ ...states, [key]: { type: 'error', error: err } }));
  }

  public clear(key: string): void {
    this._states.update(states => {
      if (!(key in states)) {
        return states;
      }

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...rest } = states;
      return rest;
    });
  }
}
